export const PageHeader = ({ eyebrow, title, children }) => (
  <div className="wb-container pt-16 pb-12 md:pt-24 mist">
    <div className="eyebrow fade-up">{eyebrow}</div>
    <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] fade-up" style={{ animationDelay: "80ms" }}>
      {title}
    </h1>
    {children && <div className="mt-5 max-w-2xl text-sm md:text-base muted leading-relaxed fade-up" style={{ animationDelay: "160ms" }}>{children}</div>}
    <div className="gold-rule mt-10 w-40" />
  </div>
);

export const Loading = () => (
  <div className="wb-container py-32 text-center font-mono text-xs uppercase tracking-[0.3em] muted" data-testid="loading-indicator">Loading…</div>
);
